import React, { useEffect, useRef, useState } from 'react';
import { Image, Overlay, Popover } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';

import CustomTips from 'components/base/CustomTips';
import ListFilterComponent from 'components/base/ListFilterComponent';

import { CustomStatusTagFromText } from '../../components/base/CustomStatusTag';
import { CustomTitleLabel } from '../../components/earning/CustomBaseComponments';
import { DownloadTag } from '../../config/CustomEnums';
import { PermissionCodes } from '../../config/PermissionCodes';
import { ImportResource } from '../../models/DownloadImportModel';
import { checkHasPermission, createAction } from '../../utils';
import ChangePasswordPrompt from '../admin/ChangePasswordPrompt';
import AlertCentre from './AlertCentre';

import './Header.scss';
import AskAI from './AskAI'

import closeIcon from '../../assets/images/close.svg';
import vectorRightIcon from '../../assets/images/customer_overview_vector.svg';
import downloadIcon from '../../assets/images/download.svg';
import LogoutBackButton from '../../assets/images/logout_dropdown.svg';
import settingIcon from '../../assets/images/setting_icon.svg';
import taskUnio from '../../assets/images/taskUnio.svg';
import usePhoto from '../../assets/images/userPhoto.png';

const SYSTEM_TASK_TABS = {
  GENERAL: 'General',
  SECHEDULE: 'Scheduled',
};

function Header() {
  const [isOpenLogoutDropdown, setIsOpenLogoutDropdown] = useState(false);
  const [showChangePasswordPrompt, setShowChangePasswordPrompt] =
    useState(false);

  const dispatch = useDispatch();
  const systemTaskRef = useRef(null);
  const userNameRef = useRef();
  const history = useHistory();

  const [selectedTab, setSelectedTab] = useState(SYSTEM_TASK_TABS.GENERAL);
  const [search, setSearch] = useState({
    [SYSTEM_TASK_TABS.GENERAL]: '',
    [SYSTEM_TASK_TABS.SECHEDULE]: '',
  });

  const { user, systemTasks, downloadingCount, showTasks } = useSelector(
    (state) => ({
      user: state.users,
      systemTasks: state.downloadAndImport.systemTasks,
      downloadingCount: state.downloadAndImport.downloadingCount,
      showTasks: state.downloadAndImport.showTasks,
    }),
  );
  const [displaySystemTasks, setDisplaySystemTasks] = useState(systemTasks);

  const tasksIncludeSearch = (item) =>
    item.name?.toLowerCase().includes(search[selectedTab]?.toLowerCase());

  const usernameClicked = () => {
    setIsOpenLogoutDropdown(!isOpenLogoutDropdown);
  };

  const logout = () => {
    history.push({ pathname: '/login', state: { isLogout: true } });
  };

  const hasSystemTaskInfoPermission =
    checkHasPermission(user, PermissionCodes.addExportjob) ||
    checkHasPermission(user, PermissionCodes.addImportjob);

  const hasAlertCentrePermission = checkHasPermission(
    user,
    PermissionCodes.viewAndEditAlertCentre,
  );

  const canAskQuestionViaChatBot = checkHasPermission(user, PermissionCodes.canAskQuestionViaChatBot);

  const hasMaintenancePermission =
    checkHasPermission(user, PermissionCodes.viewMaintenance) ||
    checkHasPermission(user, PermissionCodes.changeMaintenance);

  useEffect(() => {
    if (hasMaintenancePermission) {
      dispatch({ type: "maintenance/getMaintenance" })
    }

    const interval = setInterval(() => {
      console.log('This will run every 2 mins!');
      if (hasSystemTaskInfoPermission) {
        dispatch(createAction('downloadAndImport/getSystemTasks')({}));
      }
      if (hasMaintenancePermission) {
        dispatch({ type: "maintenance/getMaintenance" })
      }
    }, 1000 * 60 * 2);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(()=>{
    if (showTasks) {
      setSearch(({
        [SYSTEM_TASK_TABS.GENERAL]: '',
        [SYSTEM_TASK_TABS.SECHEDULE]: '',
      }))
    }
  }, [showTasks])

  useEffect(() => {
    if (selectedTab === SYSTEM_TASK_TABS.GENERAL) {
      setDisplaySystemTasks(systemTasks?.filter(tasksIncludeSearch));
      return;
    }
    if (selectedTab === SYSTEM_TASK_TABS.SECHEDULE) {
      setDisplaySystemTasks(systemTasks?.filter(tasksIncludeSearch));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, selectedTab, systemTasks]);

  const getCancelOrDownload = (item) => {
    const showResultDownload = item?.errors?.numberOfFailed;
    if (
      (showResultDownload && item.fileUrl) ||
      item.resource === ImportResource.customerGroup
    ) {
      return (
        <a
          href={item.resultFileUrl}
          className="download-cancel-button download-button"
        >
          Result-Download
        </a>
      );
    }
    if (
      [
        ImportResource.generateGiftCard,
        ImportResource.customer,
        ImportResource.customerPreActive,
        ImportResource.createBulkReward,
        ImportResource.bulkReward,
      ].includes(item.resource) &&
      item.resultFileUrl
    ) {
      console.log('@@120');
      return (
        <a
          href={item.resultFileUrl}
          className="download-cancel-button download-button"
        >
          Result-Download
        </a>
      );
    }
    switch (item.displayStatus) {
      case DownloadTag.pendingForExport:
      case DownloadTag.pendingForGenerate:
      case DownloadTag.pendingForImport:
        return (
          <button
            type="button"
            className="btn-link reset-button download-cancel-button"
            onClick={() => {
              dispatch(
                createAction('downloadAndImport/cancelTask')({
                  pk: item.pk,
                  type: item.type,
                }),
              );
            }}
          >
            Cancel
          </button>
        );
      case DownloadTag.completed:
        return (
          // <a
          //   href={item.fileUrl}
          //   className="download-cancel-button download-button"
          // >
          //   Download
          // </a>
          <button
            type="button"
            className="btn-link reset-button download-cancel-button download-button"
            onClick={() => {
              // dispatch(
              //   createAction('downloadAndImport/downloadFile')({ id: item.id }),
              // );
              // window.location = item.fileUrl;
              let link = document.createElement('a');
              link.href = item.fileUrl;
              link.click();
              link.remove();
              dispatch({
                type: 'admin/createAuditLog',
                payload: {
                  data: {
                    exportJob: item.pk,
                  },
                },
              });
            }}
          >
            Download
          </button>
        );
      default:
        return null;
    }
  };

  const generateTypes = [
    'GENERATE_CODE_COUPON',
    'GENERATE_GENERIC_COUPON',
    'GENERATE_QR_CODE_COUPON',
    'GENERATE_IMAGE_COUPON',
  ];

  const resultTag = (item, isSuccess) => {
    const errors = item.errors;
    const resource = item.resource;
    const type = item.type;
    const status = item.status;
    const successCount = errors?.numberOfImported;
    const failedCount = errors?.numberOfFailed;
    if (!successCount && !failedCount) {
      return null;
    }
    if (type === 'EXPORT_JOB') {
      return null;
    }
    const count = isSuccess ? successCount : failedCount;
    const extraStyle = isSuccess ? 'result-success-item' : 'result-failed-item';
    let title = '';
    if (status === 'COMPLETED') {
      title = 'Imported';
    }
    if (generateTypes.includes(resource) && status === 'COMPLETED') {
      title = 'Generated';
    }
    if (!isSuccess) {
      title = 'Failed';
    }
    if (type === 'CANCELLED') {
      title = 'Cancelled';
    }
    if (!title) {
      return null;
    }
    return (
      <label className={`result-common ${extraStyle}`}>
        •{title}:{count || 0}
      </label>
    );
  };

  const downloadIconClassName = (item) => {
    if (item?.couponLink) {
      return 'download-icon-cursor';
    }
  };

  const downloadIconOnClick = (item) => {
    if (item?.couponLink) {
      return () => {
        history.push(item.couponLink);
      };
    }
  };

  const downloadLine = (item, showBorder) => {
    const successResult = resultTag(item, true);
    const errorResult = resultTag(item);
    const showOneLine = successResult || errorResult;
    return (
      <>
        <div className="system-task-row">
          <div>
            <Image
              src={taskUnio}
              className={`download-icon ${downloadIconClassName(item)}`}
              onClick={downloadIconOnClick(item)}
            />
            <div>
              <label
                className={`download-title ${
                  showOneLine
                    ? 'download-title-line-1'
                    : 'download-title-line-2'
                }`}
              >
                {item.name || '-'}
              </label>
              <div className="system-task-result-container">
                {successResult}
                {errorResult}
              </div>
            </div>
            <div
              className={`d-flex flex-column ${
                item.status !== DownloadTag.cancelled
                  ? 'system-task-row-status-downloading'
                  : 'system-task-row-status'
              } `}
            >
              {CustomStatusTagFromText(
                item.displayStatus,
                'system-task-row-status-label',
              )}
              {getCancelOrDownload(item)}
            </div>
          </div>
        </div>
        {showBorder ? <div className="system-task-row-border" /> : null}
      </>
    );
  };

  const systemTaskTabChange = (tabKey) => {
    setSelectedTab(tabKey);
  };

  return (
    <div className="header-container">
      <div
        ref={userNameRef}
        onClick={usernameClicked}
        className="header-user-area"
        style={{ position: 'relative' }}
      >
        <div className="header-text">
          <label style={{ whiteSpace: 'pre-wrap' }}>{`Hi, `}</label>
          <label className="user-name">{`${user?.username || ''}`}</label>
          <Image
            src={vectorRightIcon}
            style={{
              marginLeft: '5px',
              transform: isOpenLogoutDropdown
                ? 'rotate(-90deg)'
                : 'rotate(90deg)',
              height: '10px',
            }}
          />
        </div>
      </div>
      <Overlay
        target={userNameRef.current}
        show={isOpenLogoutDropdown}
        placement="bottom"
        rootClose
        onHide={() => {
          setIsOpenLogoutDropdown(false);
        }}
      >
        {(props) => (
          <div
            {...props}
            style={{
              ...props.style,
              zIndex: 5,
              width: '220px',
            }}
          >
            <div className="header-user-area-logout-dropdown-container">
              <Image
                className="header-user-area-logout-image"
                src={LogoutBackButton}
              />
              <div className="header-user-area-logout-dropdown-content">
                <label
                  className="header-user-area-logout-text"
                  onClick={() => {
                    setIsOpenLogoutDropdown(false);
                    setShowChangePasswordPrompt(true);
                  }}
                >
                  CHANGE PASSWORD
                </label>
                <label
                  className="header-user-area-logout-text"
                  onClick={logout}
                >
                  LOGOUT
                </label>
              </div>
            </div>
          </div>
        )}
      </Overlay>

      <div className="d-flex">
        {
          canAskQuestionViaChatBot ? (
            <AskAI/>
          ) : null
        }
        {hasAlertCentrePermission ? <AlertCentre /> : null}
        {hasSystemTaskInfoPermission ? (
          <button
            className="system-task-area"
            ref={systemTaskRef}
            onClick={() => {
              dispatch(createAction('downloadAndImport/showTasks')({}));
              dispatch(createAction('downloadAndImport/getSystemTasks')({}));
            }}
          >
            <Image src={downloadIcon} className="download-icon" />
            <label className="header-text">System task</label>
            {downloadingCount > 0 ? (
              <label className="badge-icon">{downloadingCount}</label>
            ) : null}
          </button>
        ) : null}
      </div>

      <Overlay
        target={systemTaskRef.current}
        show={showTasks}
        placement="bottom"
        rootClose
        onHide={() => {
          dispatch(createAction('downloadAndImport/hideTasks')({}));
        }}
      >
        {(props) => (
          <div
            {...props}
            className="overlay-trigger"
            style={{
              padding: '2px 10px',
              color: 'white',
              borderRadius: 3,
              ...props.style,
              zIndex: 3,
              height: 'calc(100vh - 65px)',
            }}
          >
            <Popover
              id={`popover-positioned-bottom`}
              style={{}}
              arrowProps={null}
              bsClass="systemTaskPopover"
            >
              <Popover.Title>
                <div className="system-task-header">
                  <label className="system-task center-system-task-title">System task</label>

                  <button
                    className="custom-image-button margin-left-auto"
                    onClick={() => {
                      dispatch(createAction('downloadAndImport/hideTasks')({}));
                    }}
                  >
                    <Image src={closeIcon} className="system-task-close" />
                  </button>
                </div>
              </Popover.Title>
              <Popover.Content>
                <div className="tabs">
                  <div
                    className={`tabs-tab ${
                      selectedTab === SYSTEM_TASK_TABS.GENERAL
                        ? 'tab-selected'
                        : ''
                    }`}
                    onClick={() =>
                      systemTaskTabChange(SYSTEM_TASK_TABS.GENERAL)
                    }
                  >
                    <label>{SYSTEM_TASK_TABS.GENERAL}</label>
                    <label
                      className={`${
                        downloadingCount > 0 ? 'task-badge-icon' : ''
                      }`}
                    />
                  </div>
                  <div
                    className={`tabs-tab ${
                      selectedTab === SYSTEM_TASK_TABS.SECHEDULE
                        ? 'tab-selected'
                        : ''
                    }`}
                    onClick={() =>
                      systemTaskTabChange(SYSTEM_TASK_TABS.SECHEDULE)
                    }
                  >
                    <label style={{}}>
                      {SYSTEM_TASK_TABS.SECHEDULE}
                      <CustomTips
                        customClass={{ area: 'system-task-tab-tips' }}
                        detail={
                          'Tasks with status "Scheduled import" will work from 00:00 AM to 5:00 AM'
                        }
                        placement="bottom"
                      />
                    </label>
                    <label
                      className={`${
                        downloadingCount > 0 ? 'task-badge-icon' : ''
                      }`}
                    ></label>
                  </div>
                </div>
                <div className="filter-search">
                  <ListFilterComponent
                    index={SYSTEM_TASK_TABS.GENERAL}
                    onSearch={(key) => {
                      setSearch({ ...search, [selectedTab]: key });
                    }}
                    customClass={`${
                      selectedTab === SYSTEM_TASK_TABS.GENERAL
                        ? 'showTab'
                        : 'hideTab'
                    }`}
                    preventPrefillFromLocation
                  />
                  <ListFilterComponent
                    index={SYSTEM_TASK_TABS.SECHEDULE}
                    onSearch={(key) => {
                      setSearch({ ...search, [selectedTab]: key });
                    }}
                    customClass={`${
                      selectedTab === SYSTEM_TASK_TABS.SECHEDULE
                        ? 'showTab'
                        : 'hideTab'
                    }`}
                    preventPrefillFromLocation
                  />
                </div>
                {displaySystemTasks?.length > 0 ? (
                  <PerfectScrollbar>
                    <div className="system-task-content">
                      {displaySystemTasks.map((item, index) => {
                        return downloadLine(
                          item,
                          index < displaySystemTasks.length - 1,
                        );
                      })}
                    </div>
                  </PerfectScrollbar>
                ) : (
                  <div className="system-task-no-content">
                    <CustomTitleLabel title="No task here !" />
                    <label className="tips-message">
                      No task here ! There is no uploaded or downloaded task at
                      the moment
                    </label>
                  </div>
                )}
              </Popover.Content>
            </Popover>
          </div>
        )}
      </Overlay>
      <ChangePasswordPrompt
        admin={{ username: user?.username }}
        show={showChangePasswordPrompt}
        onClose={() => setShowChangePasswordPrompt(false)}
        onConfirm={() => setShowChangePasswordPrompt(false)}
        hideCloseIcon={true}
        title={'CHANGE PASSWORD'}
        hideDescription={true}
        includeOTP={true}
      />
    </div>
  );
}

export default withRouter(Header);
